import React from 'react';
import { FiMenu } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { ReactComponent as StarIcon } from '../assets/star.svg';

const Header = ({ onMenuClick }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between p-4 lg:hidden">
        <button
            onClick={onMenuClick}
            className="p-2 rounded-full bg-black/20 hover:bg-white/20 transition-colors"
        >
            <FiMenu size={24} className="text-white" />
        </button>
        
        <Link to="/" className="w-8 h-8">
            <StarIcon />
        </Link>
    </header>
  );
};

export default Header;

